import React, { useContext, useEffect, useState } from 'react';
import { css } from '@emotion/react';
import t from 'react-translate';
import { AngularContext } from 'react-app';

import TopPanelActionButton from 'lecture_pages/components/edit-menu/actions/top-panel-action-button';
import { config } from '@config/config.json';
import CardViewButton from './card-view-button';

const styles = css`
  &.edit-left-btn {
    position: absolute;
    left: 0;
  }

  .reorder-icon {
    transform: rotate(90deg);
  }
`;

const EditModeLeftPanel = () => {
  const { $scope, injectServices } = useContext(AngularContext);
  const [TimelinesManager, CurrentCourseManager] = injectServices(['TimelinesManager', 'CurrentCourseManager']);
  const [timelineState, setTimelineState] = useState({
    lecturePagesLength: TimelinesManager.currentTimeline?.lecturePages?.length || 0,
    lectureSectionsLength: TimelinesManager.currentTimeline?.lectureSections?.length || 0,
    lectureSubsectionsLength: TimelinesManager.currentTimeline?.lectureSubsections?.length || 0,
    isReorderMode: TimelinesManager.isReorderMode(),
  });
  const isDisabled = !timelineState.lecturePagesLength;

  useEffect(() => {
    const unwatch = $scope.$watch(
      () => ({
        lecturePagesLength: TimelinesManager.currentTimeline?.lecturePages?.length || 0,
        lectureSectionsLength: TimelinesManager.currentTimeline?.lectureSections?.length || 0,
        lectureSubsectionsLength: TimelinesManager.currentTimeline?.lectureSubsections?.length || 0,
        isReorderMode: TimelinesManager.isReorderMode(),
      }),
      (newValue) => {
        setTimelineState(newValue);
      },
      true,
    );

    return () => {
      unwatch?.();
    };
  }, [$scope, TimelinesManager]);

  const handleReorder = () => {
    TimelinesManager.setReorderMode();
    $scope?.$applyAsync();
  };

  const shouldShowPlaceholder = () => {
    if (CurrentCourseManager.course.inArchiveMode) {
      return false;
    }

    if (!TimelinesManager.currentTimeline) {
      return true;
    }

    if (TimelinesManager.currentTimeline?.hasLectureComponents) {
      return false;
    }

    if (TimelinesManager.selectedTab !== 'Outline' || TimelinesManager.isEditMode() || TimelinesManager.isReorderMode()) {
      return true;
    }

    return false;
  };

  const shouldShowReorderAndCardViewButtons = !shouldShowPlaceholder()
    && (TimelinesManager.currentTimeline?.lectureSections?.length || TimelinesManager.currentTimeline?.lectureSubsections?.length);

  return (
    <React.Fragment>
      {shouldShowReorderAndCardViewButtons && (
        <div css={styles} className='edit-left-btn d-flex ml-4'>
          <TopPanelActionButton
            icon='switch'
            tooltipText={t.TIMELINE.REORDER()}
            className='reorder-icon'
            onClick={handleReorder}
            disabled={isDisabled}
            ariaLabel={t.TIMELINE.REORDER()}
            dataQa={config.pendo.outline.admin.reorderButton}
          />
          <CardViewButton />
        </div>
      )}
    </React.Fragment>
  );
};

export default EditModeLeftPanel;
